<template>
    <v-row>
        <v-col>
            <v-card elevation="1" class="pa-8">
                <h2 class="page-title pb-4">จองคิวยื่นเอกสาร</h2>
                <p class="label mb-1">1. เลือกวันที่และช่วงเวลา</p>
                <span class="grey--text text-caption pr-2">ข้อมูลคิวล่าสุด: {{ queue_time | timestamp_format }}</span>
                <v-progress-circular v-if="is_getting_queue"
                    indeterminate
                    color="purple lighten-2"
                    :size="15"
                    :width="2"
                ></v-progress-circular>
                <v-row class="mt-3">
                    <v-chip-group
                        style="width:100%"
                        active-class="grey darken-3 white--text"
                        column
                        v-model="selection"
                        @change="onDateSelected"
                    >
                        <v-col v-for="(date_slot, index) in queue_slot" :key="index" cols="12" sm="6" md="4" lg="3">
                            <v-card outlined>
                                <div class="text-center py-3"><h3 class="label">{{ date_slot.date | date_format }}</h3></div>
                                <div class="text-center grey--text">ว่าง<span class="light-green--text text--darken-1 text-h4 px-3">{{ countAvailable(date_slot) }}</span>คิว</div>
                                <v-divider class="mx-5 my-4"></v-divider>    
                                <div class="text-center grey--text text-body-2">เลือกช่วงเวลา</div>
                                <v-card-text class="text-center pt-3">
                                    <v-chip class="text-body-2">{{ date_slot.morningTimeRange }} น.
                                        <v-avatar right color="light-green darken-1" class="white--text">
                                            {{ countAvailable(date_slot, 'morning') }}
                                        </v-avatar>
                                    </v-chip>
                                    <v-chip class="text-body-2">{{ date_slot.afternoonTimeRange }} น.
                                        <v-avatar right color="light-green darken-1" class="white--text">
                                            {{ countAvailable(date_slot, 'afternoon') }}
                                        </v-avatar>
                                    </v-chip>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-chip-group>
                </v-row>
                <v-row v-if="is_show_time" class="mt-7">
                    <v-col cols="12" class="label">2. เลือกเวลา</v-col>
                    <v-col cols="12" class="pt-2">
                        <span class="text-no-wrap pr-2">วันที่ {{ queue_slot[this.date_index].date | date_format }}</span>
                        <span class="text-no-wrap">เวลา {{ day_text_format }}</span>
                    </v-col>
                    <!-- <v-col cols="12" sm="3" class="py-0">
                        วันที่ {{ queue_slot[this.date_index].date | date_format }}
                    </v-col>
                    <v-col cols="12" sm="9" class="py-0">
                        เวลา {{ day_text_format }}
                    </v-col> -->
                    <v-col v-for="(time, index) in slot_day" :key="index" cols="12" sm="4" md="3" lg="2">
                        <v-card
                            hover
                            outlined
                            :disabled="! isDateEnable(time.end) || time.is_used"
                        >
                            <div class="text-center grey--text text-body-2 pt-3">คิวที่</div>
                            <div class="text-center text-h5 pt-1 pb-2">{{ time.queue_no }}</div>
                            <div class="text-center text-body-2">{{ time.range }}</div>
                            <v-card-actions>
                                <v-btn v-if="(! isDateEnable(time.end)) && (time.is_used == false)"
                                    color="grey"
                                    block
                                    dark
                                    depressed
                                    class="ppim-btn"                                 
                                >
                                    เกินเวลา
                                </v-btn>
                                <v-btn v-else-if="! time.is_used"
                                    color="light-green darken-1"
                                    block
                                    dark
                                    depressed
                                    class="ppim-btn"
                                    @click="showDialogConfirm(time)"
                                >
                                    จองคิว
                                </v-btn>
                                <v-btn v-else
                                    color="red accent-4"
                                    block
                                    dark
                                    depressed
                                    class="ppim-btn"
                                >
                                    เต็ม
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <dialog-load
            v-model="dialog_load.show"
            :message="dialog_load.message"
        ></dialog-load>
        <dialog-alert
            v-model="dialog_alert.show"
            :type="dialog_alert.type"
            :title="dialog_alert.title"
            :message="dialog_alert.message"
            @handleCloseDialog="handleCloseDialog"
        ></dialog-alert>
        <v-dialog v-if="is_show_time"
            v-model="dialog_confirm"
            max-width="500"
            min-width="400"
            persistent
        >
            <v-card>
                <v-card-title class="purple darken-2 pt-3">
                    <v-icon left large color="white" class="d-none d-sm-flex">fas fa-exclamation-circle</v-icon>
                        <span class="white--text text-subtitle-1 text-sm-h6" id="confirm-title">กรุณายืนยันการจองคิว</span>
                </v-card-title>
                <v-card-text class="pt-5 text-center">
                    <p class="mb-0 text-body-1 mb-4">ท่านเลือกคิวส่งเอกสาร</p>
                    <p class="text-h6 text-center red--text">
                        คิวที่ {{ selected_queue.queue_no }} วันที่ {{ queue_slot[this.date_index].date | date_format }}<br />เวลา {{ selected_queue.range }}
                    </p>
                    <p class="mb-0">หากถูกต้องแล้วกรุณากดปุ่ม <strong class="text-decoration-underline">ยืนยัน</strong></p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="purple"
                        dark
                        depressed
                        @click="bookQueue"
                        class="ppim-btn"
                    >
                        ยืนยัน
                    </v-btn>
                    <v-btn
                        color="grey darken-1"
                        text
                        @click="dialog_confirm = false"
                        class="ppim-btn"
                    >
                        ย้อนกลับ
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { _, DateTime } from '@/plugins/app'
import api from '@/plugins/axios'
import { dialog_data, dialog_methods } from '@/helpers/dialog'
import DialogLoad from '@/components/DialogLoad'
import DialogAlert from '@/components/DialogAlert'

export default {
    components: {
        DialogLoad,
        DialogAlert
    },
    data: () => ({
        queue: {
            slot: []
        },
        queue_time: null,
        selection: null,
        selected_queue: {},
        date_index: 0,
        day_time: 'morning',
        is_getting_queue: false,

        dialog_confirm: false,
        ... dialog_data,
    }),
    methods: {
        isDateEnable (value) {
            // let date_slot = DateTime.fromMillis(parseInt(value.$date.$numberLong))
            // let now = DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            let date_slot = DateTime.fromISO((value))
            let now = DateTime.local().setZone('UTC')
            // let now = DateTime.local(2021, 4, 23, 10, 30, 0).setZone('UTC')

            return now <= date_slot
        },
        onDateSelected () {
            if (this.selection == undefined) return
            
            this.date_index = Math.floor(this.selection / 2)
            this.day_time = this.selection % 2 == 0 ? 'morning' : 'afternoon'
        },
        isQueueAvailable (is_used, now, end) {
            return ((is_used == false) && (now < DateTime.fromISO(end).setZone('UTC'))) ? 1 : 0
        },
        countAvailable (slot, range) {
            // let morning = _.countBy(slot.morningSlot, { is_used: false }).true
            // let afternoon = _.countBy(slot.afternoonSlot, { is_used: false }).true

            const now = DateTime.local().setZone('UTC')

            let morning = _.sumBy(slot.morningSlot, value => {
                return this.isQueueAvailable(value.is_used, now, value.end)
            })

            let afternoon = _.sumBy(slot.afternoonSlot, value => {
                return this.isQueueAvailable(value.is_used, now, value.end)
            })

            if (range == 'morning')
                return morning
            else if (range == 'afternoon')
                return afternoon
            else
                return morning + afternoon
        },
        showDialogConfirm (time_slot) {
            this.selected_queue = time_slot
            this.dialog_confirm = true
        },
        bookQueue () {
            this.dialog_confirm = false
            this.showDialogLoad(true, 'กำลังจองคิว')

            api.post('/request/eco/book_queue/' + this.$route.params.pid + '/' + this.$route.params.rid, {
                queue_no: this.selected_queue.queue_no,
                date_index: this.queue_slot[this.date_index].date_index
            }).then(response => {
                this.showDialogLoad(false)
                const result = response.data
                if (result.is_success) {
                    this.showDialogAlert(true, 'success', '', result.message + '<br /><div class="py-2"><strong>กรุณาพิมพ์ใบนัดหมายการยื่นเอกสารคำเสนอฯ ที่หน้าจอรายละเอียดคำเสนอขอขายไฟฟ้าของท่าน</strong></div>')
                    this.queue = result.request_eco_queue
                } else {
                    this.showDialogAlert(true, 'error', 'เกิดข้อผิดพลาด', result.message)
                    this.queue = result.request_eco_queue
                }
            }).catch(error => {
                this.showDialogLoad(false)
                this.showDialogAlert(true, 'error', 'เกิดข้อผิดพลาด', error.response.data.message)
            })
        },
        getQueue () {
            this.is_getting_queue = true

            api.get('/data/project/queue/' + this.$route.params.pid + '/' + this.$route.params.rid).then(response => {
                this.showDialogLoad(false)
                this.queue = response.data
                this.queue_time = DateTime.local()
                this.is_getting_queue = false
            }).catch(error => {
                if (error.response.status == 403 || error.response.status == 404) {
                    this.$router.push({ name: 'request-eco-view', params: { pid: this.$route.params.pid, rid: this.$route.params.rid }})
                }
            })
        },
        handleCloseDialog (value) {
            if (value == 'success')
                this.$router.push({ name: 'request-eco-view', params: { pid: this.$route.params.pid, rid: this.$route.params.rid }})
        },

        ...dialog_methods,
    },
    computed: {
        slot_day () {
            if (this.day_time == 'morning')
                return this.queue_slot[this.date_index].morningSlot
            else if (this.day_time == 'afternoon')
                return this.queue_slot[this.date_index].afternoonSlot
            else
                return []
        },
        queue_slot () {
            return this.queue.slot.filter(item => {
                return this.isDateEnable(item.afternoonSlot[item.afternoonSlot.length - 1].end)
            })
        },
        is_show_time () {
            return this.selection != undefined || this.selection != null
        },
        day_text_format () {
            // if (! value) return '-'
            //     console.log( this.queue_slot[this.date_index])
            return this.day_time == 'morning' ? this.queue_slot[this.date_index].morningTimeRange + ' น.' : this.queue_slot[this.date_index].afternoonTimeRange + ' น.'
        },
    },
    filters: {
        date_format (value) {
            if (! value) return '-'

            // let raw = parseInt(value.$date.$numberLong)

            // return DateTime.fromMillis(raw).setLocale('th-TH').toLocaleString(DateTime.DATE_MED)
            return DateTime.fromISO(value).setLocale('th-TH').toLocaleString(DateTime.DATE_MED)
        },
        timestamp_format (value) {
            if (! value) return '-'

            // return value.setLocale('th-TH').setLocale('th-TH').toFormat('yyyy LLL dd yyyy-MM-dd HH:mm:ss')
            return value.setLocale('th-TH').setLocale('th-TH').toLocaleString({ year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        }
    },
    created () {
        this.showDialogLoad(true, 'กำลังดึงข้อมูล')
        this.getQueue()

        setInterval(() => {
            if (this.$router.currentRoute.name == 'request-eco-queue')
                this.getQueue()
        }, 10000);
    }
}
</script>
